export enum GoFrequencyType {
    VHF = 'VHF',
    UHF = 'UHF',
}

export const GoFrequencyTypeToLabelMapping = {
    [GoFrequencyType.VHF]: 'VHF',
    [GoFrequencyType.UHF]: 'UHF',
};
